var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icon align-center flex justify-center items-center",class:_vm.cssClasses,style:(_vm.styles),domProps:{"innerHTML":_vm._s(_vm.svgSrc)},on:{"click":_vm.onClicked}})
}
var staticRenderFns = []

export { render, staticRenderFns }